import React from 'react';
import styled from 'styled-components';

import type { CourseDto } from '@/application/interfaces/pegasus.gateway';

import CourseItem from '../course-item';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
`;

type Props = {
  courses: CourseDto[];
};

const CoursesList: React.FC<Props> = ({ courses }) => {
  return (
    <Container>
      {courses.map((course) => (
        <CourseItem key={course.guid} course={course} />
      ))}
    </Container>
  );
};

export default CoursesList;
